export const MODEL_SCOPE = {
    NO_MODEL: 0,
    SITE: 1,
    EDIFICE: 2,
}